import {ref} from "vue";
import {useAuthStore} from "@/store/pinia/authStore";
import AuthService from "@/api/authService";
import {viewLog} from "@/utils/Logs";

export function useDisconnect() {
  const isDisconnecting = ref(false);

  function logout() {
    const authStore = useAuthStore();
    try {
      isDisconnecting.value = true;
      // TODO : Restore when get new domain
      // const response = await AuthService.logout();
      // console.log(response); // TODO: A tester & ajouter redirection
      AuthService.removeAuthStorage();
      AuthService.adfsLogoutRedirect();
      // return router.push({name: 'logout'});
      return;
    } catch (error) {
      viewLog.debug(error)
    }
    isDisconnecting.value = false;
  }

  return {
    logout,
    isDisconnecting,
  };
}
